//微信小程序
export const isWeiXin =
  window.navigator.userAgent.indexOf('MicroMessenger') > 0 &&
  window.__wxjs_environment === 'miniprogram'

//支付宝
export const isAliPay = window.navigator.userAgent.indexOf('AlipayClient') > 0

//广电安卓app
export const isAndroid =
  navigator.userAgent.indexOf('CBN') > -1 &&
  navigator.userAgent.indexOf('CBN_IOS') < 0

//广电iosApp
export const isIos = navigator.userAgent.indexOf('CBN_IOS') > -1

//微信环境
export const isWeiXinA =
  window.navigator.userAgent.indexOf('MicroMessenger') > 0
